<div class="ft-dropdown date-range"><span>{{ setDateLabel }}</span> <i class="ft-icn-caret-down"></i></div>
